import React from 'react';
import cl from './HomeInfo.module.css';
import { NavLink } from 'react-router-dom';
import Sale from '../../../image/sale.png';

const HomeInfo = (props) => {
  return (
    <section className={cl.about}>
      <NavLink className={cl.link_image} to="/products">
        <div className={cl.sale_image}>
          <span>Sconti fino al -90%</span>
        </div>
      </NavLink>
      <NavLink className={cl.link_image} to="/about">
        <img
          className={cl.big_image}
          src="https://bfwellness.it/wp-content/uploads/2023/03/chisiamo.jpg"
        />
      </NavLink>
    </section>
  );
};

export default HomeInfo;
